import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { formatFileSize } from './listingFileUtils';
import css from './ListingFilesSection.module.css';

/**
 * ListingFilesSection — displays listing documents on the listing page.
 *
 * @param {Array}  props.files     — from listing.attributes.publicData.files
 * @param {string} [props.className]
 */
const ListingFilesSection = ({ files = [], className }) => {
  if (!files || files.length === 0) return null;

  return (
    <section className={classNames(css.root, className)}>
      <h2 className={css.title}>
        <FormattedMessage id="ListingFilesSection.title" />
      </h2>
      <ul className={css.list}>
        {files.map(file => (
          <li key={file.key} className={css.item}>
            <a
              href={file.url}
              target="_blank"
              rel="noopener noreferrer"
              className={css.fileLink}
            >
              <span className={css.icon}>📄</span>
              <span className={css.fileName}>{file.name}</span>
              {file.size ? (
                <span className={css.fileSize}>{formatFileSize(file.size)}</span>
              ) : null}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ListingFilesSection;
